import React, { useMemo } from "react";
import { PaginatedPost } from "../log.typing";
import Grouped from "./Grouped";

type PostsByDateProps = {
  posts: PaginatedPost[];
  getMap: () => Map<string, HTMLElement>;
};

/** Posts under a heading per day, keeping their order. */
export const PostsByDate = ({ posts, getMap }: PostsByDateProps) => {
  const postsByDate = useMemo(
    () =>
      posts.reduce<Record<string, PaginatedPost[]>>((groups, post) => {
        const date = post?.Date ?? "";
        if (!groups[date]) groups[date] = [];
        groups[date].push(post);
        return groups;
      }, {}),
    [posts]
  );

  return (
    <>
      {Object.entries(postsByDate).map(([date, datePosts]) => (
        <Grouped getMap={getMap} key={date} date={date} posts={datePosts} />
      ))}
    </>
  );
};
